<template>
  <v-container grid-list-lg class="pa-0 ma-0" fluid>

    <v-layout row wrap>
      <v-flex xs12 class="pt-0 pb-0">
        <v-card flat :style="!$vuetify.breakpoint.smAndDown ? 'padding-left: 90px; padding-right: 90px;' : 'padding-top: 15px; padding-bottom: 5px;'">
          <v-card-title class="pt-0 pb-0">
            <v-layout row wrap :align-center="$vuetify.breakpoint.smAndUp" :align-content-center="$vuetify.breakpoint.smAndDown">

              <v-flex xs12 sm3 md2 lg1>
                <v-menu
                  v-model="filtro.status.opened"
                  :close-on-content-click="false"
                  offset-y
                  transition="slide-y-transition"
                  :full-width="$vuetify.breakpoint.smAndDown"
                >
                  <v-btn
                    color="primary"
                    round
                    :outline="filtroComputed.filtroStatusString() == 'Status'"
                    slot="activator"
                    :block="$vuetify.breakpoint.smAndDown"
                  >{{filtroComputed.filtroStatusString()}}</v-btn>
                  <v-card :max-width="!$vuetify.breakpoint.smAndDown ? '170px' : ''">
                    <v-layout row wrap class="pb-0 pa-3">
                      <v-flex xs12 v-for="status in statusList" :key="status.descricao">
                        <v-btn
                          @click="filtroFunctions().selecionarStatus(status)"
                          :color="filtroComputed.statusSelecionadoDescricaoString() == status.descricao ? 'primary' : 'themeGrey'"
                          round
                          block
                          :outline="filtroComputed.statusSelecionadoDescricaoString() != status.descricao"
                        >{{status.descricao}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm11 md6 lg4>
                <transition name="fade">
                  <v-flex xs1 v-if="!filtro.pesquisa.opened">
                    <v-btn
                      @click="filtroFunctions().abrirFiltroPesquisa()"
                      color="primary"
                      round
                      outline
                      v-on="on"
                      icon
                    ><v-icon>search</v-icon></v-btn>
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="filtro.pesquisa.conteudo"
                      prepend-icon="search"
                      @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                      @blur="filtroFunctions().fecharFiltroPesquisa()"
                      label="Busca"
                      hint="Informe o nome do perfil"
                      autofocus
                      clearable
                    ></v-text-field>
                  </v-flex>
                </transition>
              </v-flex>

            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <v-container class="ml-82 mr-82 pa-24">
    
      <v-flex xs12>
        <v-layout row wrap class="scrollflex">
          <v-flex xs12  class="scrollflexcontent">
            <v-list class="pa-0" two-line>
              <v-toolbar height="56" color="primary">
                <v-flex xs6>
                  <v-toolbar-title class="subheading white--text">Perfil</v-toolbar-title>
                </v-flex>
                <v-flex xs4>
                  <v-toolbar-title class="subheading white--text">Status</v-toolbar-title>
                </v-flex>
                <v-flex xs2 text-xs-right>
                  <v-toolbar-title class="subheading white--text">Editar</v-toolbar-title>
                </v-flex>
              </v-toolbar>
              <v-list-tile v-for="perfil in perfilFilteredList" :id="'perfil-' + perfil.id" :key="perfil.id" avatar>
                <v-flex xs6>
                  <v-list-tile-content>
                    <span :id="'perfil-' + perfil.id + '-descricao'" class="themeGrey--text">
                      {{ perfil.descricao }}
                    </span>
                  </v-list-tile-content>
                </v-flex>
                <v-flex xs4>
                  <v-list-tile-content>
                    <span :id="'perfil-' + perfil.id + '-status'" class="themeGrey--text">
                      {{ perfil.ativo ? 'Ativo' : 'Inativo' }}
                    </span>
                  </v-list-tile-content>
                </v-flex>
                <v-flex xs2 text-xs-right>
                  <v-btn :id="'perfil-' + perfil.id + '-editar-btn'"
                    color="primary"
                    icon
                    @click="editarPerfil(perfil.id)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </v-flex>
              </v-list-tile>
            </v-list>
            <br>
            <div class="text-xs-center">
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-snackbar
        :timeout="6000"
        :color="snackbar.sucesso ? 'success' : 'error'"
        multi-line
        v-model="snackbar.visivel">
          {{ snackbar.mensagem }}
          <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
  </v-container>
</template>

<script>
import axios from 'axios';
import perfil from '@/helpers/perfil';
import functions from '@/components/pages/perfil/functions';
import usuarioHelper from '@/helpers/usuario-logado';

export default {
  name: 'GestaoPerfil',
  data () {
    return {
      on: null,
      perfilList: undefined,
      filtro: {
        status: {
          opened: false,
          selecionado: null
        },
        pesquisa: {
          opened: false,
          conteudo: ""
        },
      },
      statusList: [
        {
          descricao: 'Todos',
          ativo: null
        },
        {
          descricao: 'Ativos',
          ativo: true
        },
        {
          descricao: 'Inativos',
          ativo: false
        },
      ],
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: ''
      }
    }
  },
  computed: {
    perfilComputed: function() {
      return perfil;
    },
    perfilFilteredList: function() {
      const self = this;
      var filteredList = self.perfilList;
      
      if (self.perfilList != undefined) {
        filteredList = functions.filtro.status(filteredList, self.filtro.status.selecionado);
        filteredList = functions.filtro.busca(filteredList, self.filtro.pesquisa.conteudo);
        return filteredList
                .sort((a, b) => { return a.descricao.localeCompare(b.descricao) })
                .filter(a => a.id != self.perfilComputed.SERVICO);
      }
    },
    filtroComputed: function() {
      const self = this;
      return {
        filtroStatusString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado.descricao;
          } else {
            return 'Status';
          }
        },
        statusSelecionadoDescricaoString: function() {
          if (self.filtro.status.selecionado) {
            return self.filtro.status.selecionado.descricao;
          } else {
            return '';
          }
        }
      }
    }
  },
  mounted: function() {
    this.carregaPerfis();
    this.externalSnackbarMessage();
  },
  methods: {
    carregaPerfis: function() {
      const self = this;
      this.$store.commit('startLoading');
      axios.get(`${process.env.URL_USUARIOMS}/v1/buscaPerfis`, {
            headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` } })
      .then((response) => {
        self.perfilList = response.data;
        self.$store.commit('endLoading');
      });
    },
    novoPerfil: function() {
      this.$router.push('/GestaoPerfil/Cadastro');
    },
    editarPerfil: function(idPerfil) {
      this.$router.push('/GestaoPerfil/Cadastro/' + idPerfil);
    },
    externalSnackbarMessage: function () {
      const self = this;
      if (self.$route.params.snackbarMostrar) {
        self.snackbar.sucesso = self.$route.params.snackbarSucesso;
        self.snackbar.mensagem = self.$route.params.snackbarText;
        self.snackbar.visivel = self.$route.params.snackbarMostrar;
      }
    },
    filtroFunctions: function() {
      const self = this;
      return {
        selecionarStatus: function(status) {
          if (status) {
            self.filtro.status.selecionado = status;
            self.filtro.status.opened = false;
          }
        },
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (!self.filtro.pesquisa.conteudo || self.filtro.pesquisa.conteudo == '') {
            self.filtro.pesquisa.opened = false;
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.scrollflex {
  overflow-x: auto;
}
.scrollflexcontent {
  min-width: 550px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/perfil/GestaoPerfil.vue